<script lang="ts">import { cardsData } from "../data";
import Star from "../icons/star.png";
import { getVerbiageKey } from "../utils";
import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { Text } from "@infinitro/text";
import InfoCard from "./info-card.svelte";
const baseFirstRowCards = cardsData.filter((card) => card.row === 1);
let firstRowCards = baseFirstRowCards;
$: reorderPrimaryBenefitCards = $stateUi.vip.reorderPrimaryBenefitCards ?? false;
$: firstRowCards = reorderPrimaryBenefitCards ? [baseFirstRowCards[1], baseFirstRowCards[0]] : baseFirstRowCards;
</script>

<div class="tickets-container">
	<div class="features-badge">
		<img src={Star} alt={$t(Verbiage.star_alt, 'alts')} />
		<Text type="body" bodySize="small">{$t(Verbiage[getVerbiageKey('features_text')])}</Text>
	</div>
	<Text type="title" titleSize="h3" textAlign="center"
		>{$t(Verbiage[getVerbiageKey('vip_benefits_text')])}</Text
	>
	<div class="card-section">
		<div class="card-row">
			{#each firstRowCards as card}
				<InfoCard
					image={card.image}
					title={$t(card.title)}
					info={$t(card.info)}
					width={card.width}
				/>
			{/each}
		</div>
		<div class="card-row">
			{#each cardsData.filter((card) => card.row === 2) as card}
				<InfoCard
					image={card.image}
					title={$t(card.title)}
					info={$t(card.info)}
					width={card.width}
					variant="horizontal"
				/>
			{/each}
		</div>
		<div class="card-row">
			{#each cardsData.filter((card) => card.row === 3) as card}
				<InfoCard
					image={card.image}
					title={$t(card.title)}
					info={$t(card.info)}
					width={card.width}
				/>
			{/each}
		</div>
	</div>
</div>

<style>
	.tickets-container {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		gap: 0.75rem;
}

	.features-badge {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.25rem;
		border-radius: 9999px;
		padding-left: 1rem;
		padding-right: 1rem;
		padding-top: 0.25rem;
		padding-bottom: 0.25rem;
		background: var(--gradient-main);
}

	.card-section {
		margin-top: 1rem;
		display: flex;
		flex-direction: column;
		gap: 1rem;
}

	.card-row {
		display: flex;
		justify-content: center;
		gap: 1rem;
}

	.card-row > :global(.container) {
		flex: 1 1 auto;
	}

	@media (max-width: 1024px) {
		.card-row {
				flex-direction: column;
				align-items: center;
		}
	}
</style>
